<template>
  <div class="app isoti">
    <router-view/>
  </div>
</template>

<script>
export default {
}
</script>

<style>

</style>